export var ChannelValue;
(function(ChannelValue) {
    ChannelValue["awin"] = "aw";
    ChannelValue["ppcBrand"] = "aw";
    ChannelValue["ppcGeneric"] = "ppc";
    ChannelValue["facebook"] = "fb";
    ChannelValue["tiktok"] = "tiktok";
    ChannelValue["direct"] = "aw";
})(ChannelValue || (ChannelValue = {}));
